
import React from 'react'
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import { useGetPermissions } from 'layouts/customHook';
import VendorApprovalConfigsListing from './VendorApprovalConfigsListing';

const VendorApprovalConfigs = () => {
    const userPermissions = useGetPermissions('vendorApprovalConfig');
    return (
        userPermissions
            ? <VendorApprovalConfigsListing userPermissions={userPermissions} />
            : <PermisionDenied />
    );
}

export default VendorApprovalConfigs;